import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link,ReferenceOneField, TextField } from 'react-admin';
import AvatarField from './AvatarField';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
}));


const RefUserField = ({ record, size }) => {
    const classes = useStyles();
    return record ? (
        <div className={classes.root}>
            <AvatarField
                className={classes.avatar}
                record={record}
                size={size}
            />
            <Link to={`/users/${record.id}/`} >{record.referee_name}</Link>
        </div>
    ) : null;
};

export default RefUserField;
